module.exports = __webpack_public_path__ + "img/violet_035.cdf61745.png";